// pick a value based on Grommet's theme.dark so chat follows the app's light/dark mode
export const themed = (light, dark) => (props) => (props.theme && props.theme.dark ? dark : light);

export const BRAND_GREEN = "#01A982";
